/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для списка адресов доставки
   */
  app.UserDeliveryAddressListView = app.View.extend({
    el: '#delivery-address-list',
    jsonUserDeliveryAddresses: '#json-user-delivery-address',
    countDeliveryAddresses: '#countDeliveryAddresses',
    userDeliveryAddressViews: [],

    run: function (options) {
      if (options && options.settlement) {
        this.settlement = options.settlement;
      }
      var that = this;
      this.collection = new app.UserDeliveryAddresses();
      this.collection.reset(app.helpers.TemplateHelper.getJson(this.jsonUserDeliveryAddresses));

      this.listenTo(this.collection, 'sync remove', this.render);

      // создаем форму управления адресами доставки
      this.childViews.deliveryAddressFormView = new app.UserDeliveryAddressFormView({
        model: null,
        collection: this.collection,
        suggest: app.hasDaDataSuggest,
        settlement: this.settlement.clone()
      });

      this.listenTo(this.childViews.deliveryAddressFormView, 'add-user-delivery-address-form', this.addDeliveryAddress);
      this.listenTo(this.childViews.deliveryAddressFormView, 'update-user-delivery-address-form', this.updateDeliveryAddress);
      this.listenTo(this.childViews.deliveryAddressFormView, 'cancel-user-delivery-address-form', this.toggle);

      this.setViewsForDeliveryAddresses();

      this.confirmButton = this.$el.siblings().find('.confirm-rm-address');
      this.confirmButton.on('click', function () {
        var addressId = $(this).attr('data-address-model-id');
        var thisModel = that.collection.get(addressId);
        thisModel.destroy();
        var addressToRemove = $('[data-delivery-address-id=' + addressId + ']');
        addressToRemove.remove();
      });
    },

    render: function () {
      $(this.countDeliveryAddresses).text(this.collection.length);
    },

    // создаём представление для каждой модели адреса доставки и подписываемся на события этого представления
    setViewsForDeliveryAddresses: function () {
      var that = this;

      this.collection.each(function (model) {
        that.userDeliveryAddressViews[model.id] = new app.UserDeliveryAddressView(
          {'model': model, 'el': $('[data-delivery-address-id = ' + model.id + ']'), 'collection': that.collection}
        );

        that.listenTo(that.userDeliveryAddressViews[model.id], 'edit-delivery-address-view', that.edit);
      });
    },

    // Колбэк, отрабатывающий при нажатии на кнопку редактирования в представлении одного адреса доставки
    edit: function (model) {
      this.renderDeliveryAddressFormView(model);
    },

    // При нажатии на кнопку редактирования или добавления нужно отрисовать форму.
    // Здесь создаем представление формы и начинаем слушать событие ее успешного созранения.
    renderDeliveryAddressFormView: function (model) {
      this.toggle();

      this.childViews.deliveryAddressFormView.model = model;
      this.childViews.deliveryAddressFormView.render();
    },

    // Колбэк, отрабатывающий при добавлении адреса доставки
    addDeliveryAddress: function (model) {
      this.toggle();

      this.userDeliveryAddressViews[model.id] = new app.UserDeliveryAddressView({'model': model});
      this.$el.find('.list').append(this.userDeliveryAddressViews[model.id].render().el);
      this.listenTo(this.userDeliveryAddressViews[model.id], 'edit-delivery-address-view', this.edit);
    },

    updateDeliveryAddress: function (model) {
      this.toggle();
      if (model.id && this.userDeliveryAddressViews[model.id]) {
        this.userDeliveryAddressViews[model.id].render();
      }
    },
  });
})(jQuery);

}.call(window));